/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Response } from './Response';
import {
    ResponseFromJSON,
    ResponseFromJSONTyped,
    ResponseToJSON,
    ResponseToJSONTyped,
} from './Response';

/**
 * 
 * @export
 * @interface ResultOfResponse
 */
export interface ResultOfResponse {
    /**
     * 
     * @type {Response}
     * @memberof ResultOfResponse
     */
    data: Response | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfResponse interface.
 */
export function instanceOfResultOfResponse(value: object): value is ResultOfResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfResponseFromJSON(json: any): ResultOfResponse {
    return ResultOfResponseFromJSONTyped(json, false);
}

export function ResultOfResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfResponseToJSON(json: any): ResultOfResponse {
    return ResultOfResponseToJSONTyped(json, false);
}

export function ResultOfResponseToJSONTyped(value?: ResultOfResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

